import script from "./ValidatorSessionDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidatorSessionDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./ValidatorSessionDetailsPage.vue?vue&type=style&index=0&id=5718dc30&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5718dc30"]])

export default __exports__